import Icon from "@ant-design/icons";
import React from "react";

export default function ToolboxIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.25 18.5H6.75V20H17.25V18.5ZM6.75 9.5H8.75V8H6.75V9.5ZM9.5 8.75V6.75H8V8.75H9.5ZM10.75 5.5H13.25V4H10.75V5.5ZM8.75 9.5H15.25V8H8.75V9.5ZM15.25 9.5H17.25V8H15.25V9.5ZM14.5 6.75V8.75H16V6.75H14.5ZM5.5 17.25V12.75H4V17.25H5.5ZM5.5 12.75V10.75H4V12.75H5.5ZM18.5 10.75V12.75H20V10.75H18.5ZM18.5 12.75V17.25H20V12.75H18.5ZM4.75 13.5H10.75V12H4.75V13.5ZM11.75 12.5H12.25V11H11.75V12.5ZM12.25 14.5H11.75V16H12.25V14.5ZM11.5 14.25V12.75H10V14.25H11.5ZM12.5 12.75V14.25H14V12.75H12.5ZM13.25 13.5H19.25V12H13.25V13.5ZM13.25 5.5C13.9404 5.5 14.5 6.05964 14.5 6.75H16C16 5.23122 14.7688 4 13.25 4V5.5ZM11.75 14.5C11.6119 14.5 11.5 14.3881 11.5 14.25H10C10 15.2165 10.7835 16 11.75 16V14.5ZM6.75 18.5C6.05964 18.5 5.5 17.9404 5.5 17.25H4C4 18.7688 5.23122 20 6.75 20V18.5ZM12.25 16C13.2165 16 14 15.2165 14 14.25H12.5C12.5 14.3881 12.3881 14.5 12.25 14.5V16ZM17.25 20C18.7688 20 20 18.7688 20 17.25H18.5C18.5 17.9404 17.9404 18.5 17.25 18.5V20ZM12.25 12.5C12.3881 12.5 12.5 12.6119 12.5 12.75H14C14 11.7835 13.2165 11 12.25 11V12.5ZM17.25 9.5C17.9404 9.5 18.5 10.0596 18.5 10.75H20C20 9.23122 18.7688 8 17.25 8V9.5ZM9.5 6.75C9.5 6.05964 10.0596 5.5 10.75 5.5V4C9.23122 4 8 5.23122 8 6.75H9.5ZM11.5 12.75C11.5 12.6119 11.6119 12.5 11.75 12.5V11C10.7835 11 10 11.7835 10 12.75H11.5ZM6.75 8C5.23122 8 4 9.23122 4 10.75H5.5C5.5 10.0596 6.05964 9.5 6.75 9.5V8Z"
        fill="currentColor"
      />
    </svg>
  );
};
